import React from 'react';
import { routeConstants } from 'shared/constants';
const Cart = React.lazy(() => import('./'));

const cartRoute = {
  path: routeConstants.CART.route,
  component: Cart,
  protected: routeConstants.CART.protected,
};

export default cartRoute;
